import styled from 'styled-components';

import { FontSize } from '../../styles/units';

export const BusinessMessage = styled.div`
    color: #7d8294;
    font-size: ${FontSize.x_large};
    text-align: center;
`;
